// project import
import Routes from 'routes';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AppName } from 'utils/constants';
import { installNoStoreMetaTags } from 'utils/authSession';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
import './main.css';
const App = () => {
  const location = useLocation();

  useEffect(() => {
    installNoStoreMetaTags();
  }, []);

  useEffect(() => {
    const routeToTitleMap = {
      '/': `${AppName}`,
      '/404': `Page Not Found | ${AppName}`,
      '/salesorder': `Sales Order | ${AppName}`,
      '/sales-performer': `Sales Order Performa | ${AppName}`,
      '/sales-performer-report': `Sales Order Performa Report | ${AppName}`,
      '/dashboard': `Dashboard | ${AppName}`,
      '/barcodeSO': `Barcode Scanner Fabric | ${AppName}`,
      '/barcodeSOg': `Barcode Scanner Garment | ${AppName}`,
      '/stockselectionf': `Stock Selection Fabric | ${AppName}`,
      '/stockselectiong': `Stock Selection Garment | ${AppName}`,
      '/productBookingf': `Product Booking Fabric | ${AppName}`,
      '/productBookingg': `Product Booking Garment | ${AppName}`,
      '/deliveryschedulef': `Delivery Schedule Fabric | ${AppName}`,
      '/deliveryscheduleg': `Delivery Schedule Garment | ${AppName}`,
      '/saleorderdetails': `Order Details Garment| ${AppName}`,
      '/saleorderdetailsf': `Order Details Fabric | ${AppName}`,
      '/deliveryconfirmation': `Delivery Confirmation | ${AppName}`,
      '/barcodedashboard': `Barcode Dashboard | ${AppName}`,
      '/attedancereport': `Attendance Report | ${AppName}`,
      '/myordersreport': `My Orders Report | ${AppName}`,
      '/customerProfile': `Customer Profile | ${AppName}`,
      '/check-barcode-for-stock': `Check Barcode Stock | ${AppName}`,
      '/samplecheck': `Sample Check Garment| ${AppName}`,
      '/samplecheckf': `Sample Check Fabric | ${AppName}`,
      '/ledger': `Ledger Report | ${AppName}`,
      '/seoreport': `SEO Report | ${AppName}`,
      '/stockdownload': `Stock Download | ${AppName}`,
      '/stockupload': `Stock Upload | ${AppName}`,
      '/salesOrderUpload': `Sales Order Upload | ${AppName}`,
      '/login': `Login | ${AppName}`,
      '/forgotpass': `Forgot Password | ${AppName}`,
      '/otpverify': `Verify OTP | ${AppName}`,
      '/reset-password': `Reset Password | ${AppName}`,
      '/ledgerCurrentYear': `Ledger Current Year | ${AppName}`,
      '/ledgerDiv': `Division Wise Ledger | ${AppName}`,
      '/ledgerCurrentYearDetails': `Ledger Detail | ${AppName}`,
      '/ledgerDivDetails': `Ledger Detail | ${AppName}`,
      '/ledgerPreviousYear': `Ledger Previous Year | ${AppName}`,
      '/ledgerpreviousYear': `Ledger Previous Year | ${AppName}`,
      '/previousDivWiseLedger': `Division Wise Previous Ledger | ${AppName}`,
      '/previousDivWiseLedgerDetails': `Ledger Detail | ${AppName}`,
      '/ptFile': `PT File | ${AppName}`,
      '/vendorLedger': `Vendor Ledger | ${AppName}`,
      '/vendorledgerDetails': `Vendor Ledger Detail | ${AppName}`,
      '/passessment': `Product Assessment | ${AppName}`,
      '/divoutstanding': `Division Wise Outstanding | ${AppName}`,
      '/divoutstandingnew': `Division Wise Outstanding | ${AppName}`,
      '/assessment-reports': `Assessment Reports | ${AppName}`,
      '/ledgerPreviousYearDetails': `Ledger Detail | ${AppName}`,
      '/beats': `BEATS | ${AppName}`,
      '/beat-customers': `BEATS Customers | ${AppName}`,
      '/beat-customer-reports': `BEATS Customer Reports | ${AppName}`,
      '/beat-planning': `BEATS Planning | ${AppName}`,
      '/distributorkpi-reports': `KPI Reports | ${AppName}`,
      '/market-intelligence': `Market Intelligence | ${AppName}`,
      '/product-catalogue': `Product Catalogue | ${AppName}`,
      '/user-reports': `User Reports | ${AppName}`,
      '/good-returns-list': `Good Returns List | ${AppName}`,
      '/good-returns': `Good Returns | ${AppName}`,
      '/good-returns-transfer': `Good Returns Transfer | ${AppName}`,
      '/sfa-stockselectionf': `SFA Stock Selection Fabric | ${AppName}`,
      '/sfa-productBookingf': `SFA Product Booking Fabric | ${AppName}`,
      '/sfa-deliveryschedulef': `SFA Delivery Schedule Fabric | ${AppName}`,
      '/view-sample-request': `Sample Request Report | ${AppName}`,
      '/sample-request-dashboard': `Sample Request Dashboard | ${AppName}`,
      '/tour-expense-claim': `Tour Expense Claim | ${AppName}`,
      '/display-and-events': `Display and Events | ${AppName}`,
      '/denknit-sales-order-summary-report': `Denknit Sales Order Summary Report | ${AppName}`,
      '/sample-design': `Sample Design | ${AppName}`,
      '/sample-request-barcode-scan': `Sample Request Barcode Scan | ${AppName}`,
      '/sample-request-selection': `Sample Request Selection | ${AppName}`,
      '/Denknit-sample_process': `Denknit Sample Process | ${AppName}`,
      '/Denknit-sample_process/add': `Add Sample Process | ${AppName}`,
      '/Denknit-sample_process/barcode-dashboard': `Denknit Barcode Dashboard | ${AppName}`,
      '/Denknit-sample_process/barcode-scan': `Denknit Barcode Scanner | ${AppName}`,
      '/Denknit-sample_process/fabric-selection': `Denknit Fabric Selection | ${AppName}`,
      '/Denknit-sample_process/garment-selection': `Denknit Garment Selection | ${AppName}`,
      '/Denknit-sample_process/fabric-product-booking': `Denknit Fabric Stock Booking | ${AppName}`,
      '/Denknit-sample_process/garment-product-booking': `Denknit Garment Stock Booking | ${AppName}`,
      '/Denknit-sample_process/fabric-checkout': `Denknit Fabric Checkout | ${AppName}`,
      '/Denknit-sample_process/garment-checkout': `Denknit Garment Checkout | ${AppName}`,
      '/secondary-sales-order': `Secondary Sales Order | ${AppName}`,
      '/secondary-sales-order/add': `Create Secondary Sales Order | ${AppName}`,
      '/secondary-sales-order/barcode-dashboard': `Secondary Sales Barcode Dashboard | ${AppName}`,
      '/secondary-sales-order/barcode-scan': `Secondary Sales Barcode Dashboard | ${AppName}`,
      '/secondary-sales-order/barcode-entry': `Secondary Sales Barcode Scan | ${AppName}`,
      '/secondary-sales-order/products': `Secondary Sales Products | ${AppName}`,
      '/sample-design-sales-planning': `Sample Design Sales Planning | ${AppName}`,
      '/barcode-scan-sales-planning': `Barcode Scan Sales Planning | ${AppName}`,
      '/dashboard-sales-planning': `Sales Planning Dashboard | ${AppName}`,
      '/sample-selection-sales-planning': `Sample Selection Sales Planning | ${AppName}`,
      '/pending-order-reports': `Pending Order Reports | ${AppName}`,
      '/outstanding-reports': `Outstanding Reports | ${AppName}`,
      '/collection-recieved': `Collection Recieved | ${AppName}`,
      '/scheme-report': `Scheme Report | ${AppName}`,
      '/report-dashboard': `Report Dashboard | ${AppName}`,
      '/collection-target-achv-report': `Collection Target Achv Report | ${AppName}`,
      '/current-month-sales-report': `Current Month Sales Figure | ${AppName}`,
      '/agency-performance-report': `Agency Performance | ${AppName}`,
      '/dealer-one-page-report': `Dealer One Page Report | ${AppName}`,
      '/agency-one-page-report': `Agency One Page Report | ${AppName}`,
      '/non-billed-reports': `NON BILLED REPORT | ${AppName}`,
       "/sales-person-entry-for-visit": `Sales Person Entry For Visit | ${AppName}`,
    };

    const currentPath = location.pathname;
    document.title = routeToTitleMap[currentPath] || 'Default Title';
  }, [location.pathname]);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <Routes />
      </ScrollTop>
    </ThemeCustomization>
  );
};

export default App;
